import { useState, useEffect } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { useUser } from '../components/UserContext';

/**
 * Emails sent about the client user's clientes (email_log rows), newest
 * first, sent-only. Backs the portal's Bandeja de entrada and its sidebar
 * unread dot. Returns null while loading.
 */
export function useBandejaEmails() {
  const { userData } = useUser();
  const [emails, setEmails] = useState(null);
  const clientIdsKey = JSON.stringify(userData?.clientIds || []);

  useEffect(() => {
    const clientIds = JSON.parse(clientIdsKey);
    if (userData?.rol !== 'client' || !userData?.org || clientIds.length === 0) {
      setEmails([]);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const chunks = [];
        for (let i = 0; i < clientIds.length; i += 10) {
          chunks.push(clientIds.slice(i, i + 10));
        }
        const snaps = await Promise.all(chunks.map((chunk) => getDocs(query(
          collection(db, 'email_log'),
          where('orgId', '==', userData.org),
          where('clientId', 'in', chunk),
        ))));
        const rows = snaps
          .flatMap((snap) => snap.docs.map((d) => ({ id: d.id, ...d.data() })))
          .filter((row) => row.status === 'sent');
        rows.sort((a, b) => (b.sentAt?.toMillis?.() || 0) - (a.sentAt?.toMillis?.() || 0));
        if (!cancelled) setEmails(rows);
      } catch (e) {
        console.error('Failed to load bandeja emails:', e);
        if (!cancelled) setEmails([]);
      }
    })();
    return () => { cancelled = true; };
  }, [userData?.rol, userData?.org, clientIdsKey]);

  return emails;
}
